<template>
<div>
  <div id="page">
    <div class="row topCardGrid">
        <sp-card stripe="" :valor="cardData.itens.fila_espera" :descricao="$t('graficosSaude.filas.cards.fila')" :footerText="dataRef"/>
        <sp-card stripe="" :valor="cardData.itens.fluxo_entrada" :descricao="$t('graficosSaude.filas.cards.fluxo', {mes : cardData.dataRef})" :footerText="dataRef"/>
        <sp-card stripe="" :valor="cardData.itens.oferta" :descricao="$t('graficosSaude.filas.cards.oferta')" :footerText="dataRef"/>
    </div>
    <div class="flex row">
        <div class="flex chartPanel">
          <sp-360-panel :title="$t('graficosSaude.filas.filaConsulta.painel.filaProcedimento')" footerText=" ">
            <!-- <div class="flex column v-chart">
            <sp-360-chart id="filaProcedimento" type="vertical-bar" :data="filaProcedimento.chartData" :options="filaProcedimento.options" />
            </div> -->
            <!-- <div class="flex column h-chart"> -->
              <sp-360-chart id="filaEspeciadade" type="horizontal-bar" :data="filaEspeciadade.chartData" :options="filaEspeciadade.options" />
            <!-- </div> -->
            <div slot="footerActions">
              <va-button v-show="showbuttom1()"  color="danger" class="pull-right"  @click="openModalLista1($event)">
                {{$t('graficosSaude.filas.detalhes.botao')}}
              </va-button>
            </div>
          </sp-360-panel>
        </div>
        <div class="flex chartPanel">
          <sp-360-panel :title="$t('graficosSaude.filas.filaConsulta.painel.fluxoProcedimento')" footerText=" ">
            <!-- <div class="flex column v-chart">
              <sp-360-chart id="fluxoProcedimento" type="vertical-bar" :data="fluxoProcedimento.chartData" :options="fluxoProcedimento.options" />
            </div> -->
            <!-- <div class="flex column h-chart"> -->
              <sp-360-chart id="fluxoEspeciadade" type="horizontal-bar" :data="fluxoEspeciadade.chartData" :options="fluxoEspeciadade.options" />
            <!-- </div> -->
            <div slot="footerActions">
              <va-button v-show="showbuttom1()"  color="danger" class="pull-right"  @click="openModalLista1($event)">
                {{$t('graficosSaude.filas.detalhes.botao')}}
              </va-button>
            </div>
          </sp-360-panel>
        </div>
        <div class="flex chartPanel">
          <sp-360-panel :title="$t('graficosSaude.filas.filaConsulta.painel.ofertaProcedimento')" footerText=" ">
            <!-- <div class="flex column v-chart">
            <sp-360-chart id="ofertaProcedimento" type="vertical-bar" :data="ofertaProcedimento.chartData" :options="ofertaProcedimento.options"/>
            </div> -->
            <!-- <div class="flex column h-chart"> -->
              <sp-360-chart id="conslidadoProcedimento" type="horizontal-bar" :data="ofertaEspeciadade.chartData" :options="ofertaEspeciadade.options"/>
            <!-- </div> -->
              <!-- <sp-360-chart id="ofertaEspeciadade" type="horizontal-bar" :data="crescimento.chartData" :options="crescimento.options"/> -->
            <div slot="footerActions">
                <va-button v-show="showbuttom1()"  color="danger" class="pull-right"  @click="openModalLista1($event)">
                  {{$t('graficosSaude.filas.detalhes.botao')}}
                </va-button>
            </div>
          </sp-360-panel>
        </div>
    </div>
    <div class="flex row">

    </div>
  </div>
  <div id="modals">
    <va-modal show.sync="true" ref="modalLista1" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'"
      size="large" maxWidth="100em" fixedLayout=true v-model="showModalLista1" :title="$t('graficosSaude.filas.filaExame.painel.filaProcedimento')" :cancelText="''">
      <template slot="default">
        <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="listaTabela1"
          :fields="camposTabelaLista1" :perPage="itemsPerPage" :onEachSide="onEachSide"
            />
      </template>
    </va-modal>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import * as d3 from 'd3'

export default {
  name: 'fila-consultas',
  mixins: [],
  components: { SpCard, Sp360Chart, Sp360Panel, Multiselect, Sp360DataTable },

  data () {
    return {
      tooltipOptions: {
        content: '',
        placement: 'top',
      },
      cardData: {
        itens: { fila_espera: 0, fluxo_entrada: 0, oferta: 0 },
        dataRef: 0,
      },
      filaProcedimento: {
        chartData: {},
        options: {},
      },
      ofertaProcedimento: {
        chartData: {},
        options: {},
      },
      fluxoProcedimento: {
        chartData: {},
        options: {},
      },
      filaEspeciadade: {
        chartData: {},
        options: {},
      },
      fluxoEspeciadade: {
        chartData: {},
        options: {},
      },
      ofertaEspeciadade: {
        chartData: {},
        options: {},
      },
      crescimento:{
         chartData: {},
         options: {},
      },

      onEachSide: 1,
      showModalLista1: false,
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.TAMANHO_TABELAS,
      camposTabelaLista1: [
      ],
      sortFunctionsCamposTabelaLista1: {
      },
    }
  },

  // filaDeProcedimentoConsolidadoPorClasse
  // filaDeProcedimentoPorProcedimento
  // filaDeProcedimentoPorGrupoDeProcedimentos
  // filaDeProcedimentoDetalhadoPorClasseDeProcedimento
  // filaDeProcedimentoDetalhado
  // filaDeProcedimentoPorEspecialidade

  created () {
    Promise.all([
      this.$store.dispatch('saude/filaDeProcedimentoConsolidadoPorClasse', { classeProcedimento: 'CONSULTA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorProcedimento', { classeProcedimento: 'CONSULTA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorGrupoDeProcedimentos', { classeProcedimento: 'CONSULTA' }),
      this.$store.dispatch('saude/filaDeProcedimentoDetalhadoPorClasseDeProcedimento', { classeProcedimento: 'CONSULTA' }),
      this.$store.dispatch('saude/filaDeProcedimentoDetalhado', { classeProcedimento: 'CONSULTA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorEspecialidade', { classeProcedimento: 'CONSULTA' }),
    ]).then((respostas) => {
      this.dataRef = this.$t('rodape.fonteData', { fonte: respostas[0].data.sigla_orgao + '/' + respostas[0].data.fonte, data: MethGlob.formataDataParaStringDataLocal(new Date(respostas[0].data.data_referencia_dado)) })
      this.cardData = this.popularCards(respostas[0].data)
      let corA = CorUtils.getCorPorNomeSp360('azul-columbia-claro')
      let corB = CorUtils.getCorPorNomeSp360('amarelo-pera-claro')
      let corC = CorUtils.getCorPorNomeSp360('purpura-claro')

      let procedimentos = this.$t('graficosSaude.filas.filaConsulta.painel.procedimento')
      let pessoasNaFila = this.$t('graficosSaude.filas.filaConsulta.painel.pessoasNaFila')
      let fluxoEntrada = this.$t('graficosSaude.filas.filaConsulta.painel.fluxoEntrada')
      let oferta = this.$t('graficosSaude.filas.filaConsulta.painel.oferta')

      // // TopPanels
      // this.popularGraficoDeLinha(this.filaProcedimento, _.orderBy(respostas[1].data.data, 'fila_espera', 'desc'), 'fila_espera', 'procedimento', corA, true)
      // this.filaProcedimento.options = this.filaProcedimentoChartOptions(procedimentos, pessoasNaFila, 'titulo', true)
      // this.popularGraficoDeLinha(this.fluxoProcedimento, _.orderBy(respostas[1].data.data, 'fluxo_entrada', 'desc'), 'fluxo_entrada', 'procedimento', corB, true)
      // this.fluxoProcedimento.options = this.filaProcedimentoChartOptions(procedimentos, fluxoEntrada, 'titulo', true)
      // this.popularGraficoDeLinha(this.ofertaProcedimento, _.orderBy(respostas[1].data.data, 'oferta', 'desc'), 'oferta', 'procedimento', corC, true)
      // this.ofertaProcedimento.options = this.filaProcedimentoChartOptions(procedimentos, oferta, 'titulo', true)

      // BottomPanels
      this.popularGraficoDeLinha(this.filaEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'fila_espera', 'desc')), 'fila_espera', 'grupo_procedimento', corA)
      this.filaEspeciadade.options = this.getchartOptions(pessoasNaFila, procedimentos, 'titulo', true)

      this.popularGraficoDeLinha(this.fluxoEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'fluxo_entrada', 'desc')), 'fluxo_entrada', 'grupo_procedimento', corB)
      this.fluxoEspeciadade.options = this.getchartOptions(fluxoEntrada, procedimentos, 'titulo', true)

      this.popularGraficoDeLinha(this.ofertaEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'oferta', 'desc')), 'oferta', 'grupo_procedimento', corC)
      this.ofertaEspeciadade.options = this.getchartOptions(oferta, procedimentos, 'titulo', true)

      this.popularTabelaModal(respostas[3].data.data)
    })
  },
  methods: {
    agruparDados (dados) {
      let clone = _.cloneDeep(dados)
      let top10 = clone.splice(0, 10)
      let reduced = _.reduceRight(clone, (acc, e) => {
        acc.grupo_procedimento = 'Outros'
        acc.procedimento += e.procedimento
        acc.especialidade += e.especialidade
        acc.fila_espera += e.fila_espera
        acc.fluxo_entrada += e.fluxo_entrada
        acc.oferta += e.oferta
        return acc
      }, {
        grupo_procedimento: 'Outros',
        procedimento: 'Outros',
        especialidade: 0,
        fila_espera: 0,
        fluxo_entrada: 0,
        oferta: 0,
        classe_procedimento: 'PROCEDIMENTO',
      })
      top10.push(reduced)
      return top10
    },

    popularCards (data) {
      return {
        itens: _.find(data.data, (e) => { return e.classe_procedimento === 'CONSULTA' }),
        dataRef: data.data[0].mes_entrada + '/' + new Date(data.data_referencia_dado).getFullYear()
      }
    },

    popularGraficoDeLinha (chartObject, data, prop, labelProp, colorSet, wordwrap = false) {
      let dados = data
      let Labels = []

      let dataSet = {
        label: '',
        backgroundColor: colorSet,
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        // yAxisID: 'y-axis-1',
      }

      dados.forEach((el) => {
        if (el[prop]) {
          dataSet.label = el[labelProp]
          dataSet.data.push(el[prop])
          if (wordwrap) {
            let entry = el[labelProp].split(' ')
            Labels.push(entry)
          } else {
            Labels.push(el[labelProp])
          }
        }
      })

      let datasets = []
      datasets.push(dataSet)

      chartObject.chartData = { datasets: datasets, labels: Labels }
    },

    filaProcedimentoChartOptions (xAxixLabel, yAxixLabel, titulo) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = tooltipItem.xLabel.join(' ') + '  ' || ''
              } else {
                label = tooltipItem.xLabel + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.yLabel)
              return label
            },
          },
        },
        maintainAspectRatio: false,
        aspectRatio: 16,
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          xAxes: [{
            categoryPercentage: 0.6,
            barPercentage: 1.0,
            display: true,
            type: 'category',
            distribution: 'series',
            ticks: {
              min: 0,
              autoSkip: false,
              fontSize: 8,
            },
            scaleLabel: {
              display: false,
              labelString: this.$t(xAxixLabel || 'LegendaX'),
            },

          }],
          yAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 8,
              callback: (value) => MethGlob.formatarNumero(value),
            },
            id: 'y-axis-1',
            type: 'logarithmic',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(yAxixLabel || 'LegendaY'),
            },
          },
          // {
          //   id: 'y-axis-2',
          //   ticks: {
          //     min: 0, // minimum tick
          //     callback: (value) => value.toLocaleString('pt-BR'),
          //   },
          //   type: 'logarithmic',
          //   position: 'right',
          //   display: true,
          //   scaleLabel: {
          //     display: true,
          //     labelString: this.$t('assistencia.servicos.grafico.legendaX2'),
          //   },
          // }
          ],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              size: 16,
              weight: 'bold',
            },
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            display: false,
          },
        },
      }
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = tooltipItem.yLabel.join(' ') + '  ' || ''
              } else {
                label = tooltipItem.yLabel + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.xLabel)
              return label
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          xAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },
            type: 'logarithmic',
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          },
          ] },
      }
    },

    popularTabelaModal (data) {
      this.listaTabela1 = _.orderBy(data, 'procedimento')
      this.camposTabelaLista1 = [
        // {
        //   name: 'classe_procedimento',
        //   sortField: 'classe_procedimento',
        //   title: this.$t('graficosSaude.filas.detalhes.campos.classe_procedimento'),
        //   width: '54%',
        // },
        {
          name: 'procedimento',
          sortField: 'procedimento',
          title: this.$t('graficosSaude.filas.detalhes.campos.procedimento'),
          width: '54%',
        },
        {
          name: 'especialidade',
          sortField: 'especialidade',
          title: this.$t('graficosSaude.filas.detalhes.campos.especialidade'),
          width: '6%',
        }, {
          name: 'fila_espera',
          sortField: 'fila_espera',
          title: this.$t('graficosSaude.filas.detalhes.campos.fila_espera'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        }, {
          name: 'fluxo_entrada',
          sortField: 'fluxo_entrada',
          title: this.$t('graficosSaude.filas.detalhes.campos.fluxo_entrada'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        }, {
          name: 'oferta',
          sortField: 'oferta',
          title: this.$t('graficosSaude.filas.detalhes.campos.oferta'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        }]
      this.sortFunctionsCamposTabelaLista1 = {
        'classe_procedimento': MethGlob.ordenaTabela,
        'especialidade': MethGlob.ordenaTabela,
        'procedimento': MethGlob.ordenaTabela,
        'fila_espera': MethGlob.ordenaTabelaParseInt,
        'fluxo_entrada': MethGlob.ordenaTabelaParseInt,
        'oferta': MethGlob.ordenaTabelaParseInt,
      }
    },

    openModalLista1 () { this.showModalLista1 = !this.showModalLista1 },
    showbuttom1 () {
      return true
    },
  },
}
</script>

<style lang="scss" scoped >
.chartPanel{
  .va-chart {
    max-height: 50rem;
  }
    width: 100%;
}
.toprow{
  height: 40rem;
  width: 100%;
}

.v-chart{
  width: 40%;
}
.h-chart{
  width: 60%;
}

.column {
  float: left;
}
</style>
